function GridHeader({ headers, className = "" }) {
  return (
    <>
      {headers.map((header, idx) => (
        <span
          key={idx}
          className={`font-bold text-gray-400 text-sm ${className}`}
        >
          {header}
        </span>
      ))}
    </>
  );
}

export default GridHeader;
